import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const merge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["2xs"],
      shadow: ["2xs", "xs"],
      spacing: ["4.5", "13", "68", "70", "77.5"],
      radius: ["xs"],
      color: [
        "primary", "primary-foreground", "primary-hover", "primary-active", "primary-muted", "primary-muted-foreground",
        "shell", "shell-foreground", "shell-border", "destructive-hover",
        ...["success", "warning", "info", "destructive", "turkuaz"].flatMap((tone) =>
          [tone, `${tone}-foreground`, `${tone}-muted`, `${tone}-muted-foreground`]),
      ],
    },
  },
});

/** Birleştirir; BTS token ölçeklerini korur ve son className override'ını uygular. */
export function cn(...inputs) {
  return merge(clsx(inputs));
}
